import { TextArea, IconButton } from "../ui/controls";

/**
 * Edits the prière universelle intentions as discrete petitions.
 * Stored as a newline-joined string (one petition per line) so the .docx export
 * is unchanged; pasting multi-line text or pressing Enter splits into petitions.
 */
export function IntentionsEditor({ value, onChange }: { value: string; onChange: (v: string) => void }) {
  const items = value.length ? value.split("\n") : [""];
  const commit = (next: string[]) => onChange((next.length ? next : [""]).join("\n"));

  function update(i: number, v: string) {
    const parts = v.split("\n");
    const next = [...items];
    next.splice(i, 1, ...parts);
    commit(next);
  }
  function remove(i: number) {
    commit(items.filter((_, j) => j !== i));
  }
  function add() {
    commit([...items, ""]);
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {items.map((it, i) => (
        <div key={i} style={{ display: "flex", gap: "8px", alignItems: "flex-start" }}>
          <span style={{ fontFamily: "var(--font-serif)", fontSize: "var(--text-md)", color: "var(--accent-text)", lineHeight: "2em", flexShrink: 0 }}>—</span>
          <div style={{ flex: 1 }}>
            <TextArea rows={1} value={it} placeholder="Pour… : que… Prions le Seigneur." onChange={(v) => update(i, v)} />
          </div>
          <IconButton aria-label="Supprimer l'intention" variant="ghost" size="sm" onClick={() => remove(i)} style={{ marginTop: 4 }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
          </IconButton>
        </div>
      ))}
      <button
        type="button"
        onClick={add}
        style={{ alignSelf: "flex-start", display: "inline-flex", alignItems: "center", gap: 6, border: "1px dashed var(--border-strong)", background: "transparent", color: "var(--accent-text)", borderRadius: "var(--radius-md)", padding: "6px 12px", cursor: "pointer", fontFamily: "var(--font-ui)", fontSize: "var(--text-sm)", fontWeight: 600 }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14M5 12h14" /></svg>
        Ajouter une intention
      </button>
    </div>
  );
}
